import {
  URLAPI,
  STORES_PATH,
  STORE_CREATE_PATH,
  STORE_UPDATE_PATH,
} from "../config/index";
import { LOGOUT } from './users'
import axios from "axios";

const init = {
  _get_all_stores: {
    data: [],

    status: 0,
    message: {},
  },

  _create_store: {
    data: {},
    status: 0,
    message: {},
  },
  _update_store: {
    data: {},
    status: 0,
    message: {},
  },
};

const GET_ALL_STORES = "GET_ALL_STORES";
export const CREATE_STORE = "CREATE_STORE";
export const UPDATE_STORE = "UPDATE_STORE";

export const stores_module = (state = init, action) => {
  switch (action.type) {
    case GET_ALL_STORES:
      return {
        ...state,
        _get_all_stores: action.payload,
      };
    case CREATE_STORE:
      return {
        ...state,
        _create_store: action.payload,
      };
    case UPDATE_STORE:
      return {
        ...state,
        _update_store: action.payload,
      };
    case LOGOUT:
      return init;
    default:
      return state;
  }
};

export const getAllStores = (token) => async (dispatch) => {
  try {
    const response = await axios.get(`${URLAPI}${STORES_PATH}`, {
      headers: {
        Authorization: `Basic ${token}`,
      },
    });
    dispatch({
      type: GET_ALL_STORES,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: GET_ALL_STORES,
        payload: {
          data: [],
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: GET_ALL_STORES,
        payload: {
          data: [],
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const searchStores = async (token, paramsUrl) => {
  return await axios.get(`${URLAPI}${STORES_PATH}${paramsUrl}`, {
    headers: {
      Authorization: `Basic ${token}`,
    },
  });
}

export const createStore = (token, data) => async (dispatch) => {
  try {
    let form = new FormData();

    for (var key in data) {
      form.append(key, data[key]);
    }
    const response = await axios.post(
      `${URLAPI}${STORE_CREATE_PATH}`,
      form,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    dispatch({
      type: CREATE_STORE,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: CREATE_STORE,
        payload: {
          data: {},
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: CREATE_STORE,
        payload: {
          data: {},
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const updateStore = (token, id, data) => async (dispatch) => {
  try {
    let form = new FormData();

    for (var key in data) {
      form.append(key, data[key]);
    }
    const response = await axios.patch(
      `${URLAPI}${STORE_UPDATE_PATH}${id}/`,
      form,
      {
        headers: {
          Authorization: `Basic ${token}`,
        },
      }
    );
    dispatch({
      type: UPDATE_STORE,
      payload: {
        data: response.data,
        status: response.status,
        message: "",
      },
    });
  } catch (error) {
    if (error.response) {
      dispatch({
        type: UPDATE_STORE,
        payload: {
          data: {},
          status: error.response.status,
          message: error.response.data.mensaje,
        },
      });
    } else {
      dispatch({
        type: UPDATE_STORE,
        payload: {
          data: {},
          status: 500,
          message: error.message,
        },
      });
    }
  }
};

export const clear_stores = (type) => async (dispatch) => {
  dispatch({
    type: type,
    payload: {
      data: [],
      status: 0,
      message: {},
    },
  });
};
